
interface TwoBtnsProps {
  leftTitle?: string;
  rightTitle?: string;
  onLeftClick?: () => void;
  onRightClick?: () => void;
  leftFocus?: boolean;
  rightFocus?: boolean;
}

export default function TwoBtns({
  leftTitle = '',
  rightTitle = '',
  onLeftClick = () => {},
  onRightClick = () => {},
  leftFocus = false,
  rightFocus = false,
}: TwoBtnsProps) {
  return (
    <div className="flex gap-2 justify-between w-full text-base font-[600] text-[18px] leading-6 text-center text-white bg-white">
      <button
        type="button"
        className="grow justify-center h-[56px] text-[#363636] border items-center px-1 py-3 rounded-xl cursor-pointer"
        onClick={onLeftClick}
        style={
          leftFocus
            ? { borderColor: '#5EBEBB', background: '#F0FCFC' }
            : { borderColor: '#E0E0E0', background: 'white' }
        }
      >
        {leftTitle}
      </button>
      <button
        type="button"
        className="grow justify-center border h-[56px] text-[#363636] items-center px-1 py-3 bg-[#00B4FF] rounded-xl cursor-pointer"
        onClick={onRightClick}
        style={
          rightFocus
            ? { borderColor: '#5EBEBB', background: '#F0FCFC' }
            : { borderColor: '#E0E0E0', background: 'white' }
        }
      >
        {rightTitle}
      </button>
    </div>
  );
}

